import { render, staticRenderFns } from "./HeaderWidgetAccount.vue?vue&type=template&id=6f78b11d&"
import script from "./HeaderWidgetAccount.vue?vue&type=script&lang=js&"
export * from "./HeaderWidgetAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports